import { designDisciplines } from "@/data/design-disciplines";
import { VIDEO_URLS } from "@/data/videos";

<div/target class="scroll-target"/>
<global-nav animate scrollTarget=target defaultTheme=$global.theme/>
<home-hero scrollTarget=target/>
<home-mission/>
<infinite-marquee/>
<section-observer color=null>
    <rich-text align="left" paddingBlock=["xs", "sm"]>
        <@headline>Designing the future</@headline>
        <@body>
            Our cross-functional team collaborates to evolve the eBay
            experience.
        </@body>
        <@cta href="/about" priority="secondary">
            Design in depth
        </@cta>
    </rich-text>
    <link-stack links=designDisciplines paddingBlock=["xs", "none"]/>
</section-observer>
<section-observer color="violet">
    <big-cta paddingBlock=["xl", "lg"]>
        <@headline>Ready to design your future at eBay?</@headline>
        <@cta
            href="https://jobs.ebayinc.com/us/en/c/design-ux-jobs"
            target="_blank">
            eBay Careers
        </@cta>
    </big-cta>
</section-observer>
<section-observer color=null>
    <rich-text align="left" paddingBlock=["lg", "sm"]>
        <@headline>Check out the latest</@headline>
    </rich-text>
    <content-grid emphasis="start" paddingBlock=["none", "md"]>
        <@col>
            <lightbox-video aspectRatio="5/4">
                <@poster-video
                    src=(VIDEO_URLS.reel2025Short.src)
                    poster=(VIDEO_URLS.reel2025Short.poster)
                    aria-label=(VIDEO_URLS.reel2025Short.alt)/>
                <@dialog-video
                    src=(VIDEO_URLS.reel2025Full.src)
                    poster=(VIDEO_URLS.reel2025Full.poster)
                    aria-label=(VIDEO_URLS.reel2025Full.alt)/>
            </lightbox-video>
        </@col>
        <@col>
            <img
                src="https://ir.ebaystatic.com/cr/v/c01/ebay-design/evo-tablet-2-1x1.jpg"
                alt="A Seller account view of eBay, with current listings, eBay Live streaming, and an engagement feed, shown on a tablet device."
                style={ "aspect-ratio": 1, "object-fit": "cover" }>
        </@col>
    </content-grid>
</section-observer>
<rich-text align="left" paddingBlock=["lg", "sm"]>
    <@headline>Designed to evolve</@headline>
</rich-text>
<content-grid emphasis="end" paddingBlock=["none", "xl"]>
    <@col>
        <home-text-stack/>
    </@col>
    <@col>
        <autoplay-video
            src=(VIDEO_URLS.reelEvo.src)
            poster=(VIDEO_URLS.reelEvo.poster)
            aria-label=(VIDEO_URLS.reelEvo.alt)/>
    </@col>
</content-grid>
<rich-text align="left" paddingBlock=["none", "sm"]>
    <@headline>Fresh perspectives</@headline>
    <@body>
        Check out how our team sees the world with a glimpse into our unique
        perspectives.
    </@body>
</rich-text>
<perspectives-carousel paddingBlock=["xs", "xl"] paddingInline=false/>

<style>
    .scroll-target {
        position: absolute;
        top: 0;
        left: 0;
        height: min(calc(240px + 24vw), 800px);
        width: 100vw;
        z-index: -1;
        pointer-events: none;
    }
</style>
